import { createApi } from '@core/fetch'

export default {
  isPay: createApi('/p/wedding/index.php/Admin/APIStore/status'),
  getMaterialList: createApi(
    '/p/wedding/index.php/admin/APIMerchantMaterials/simpleList'
  ),
  getCheckList: createApi('/hps/admin/cpt/adSchedule/check'),
  getPackageDetail: createApi('/hps/admin/cpt/adSchedule/detail'),
  setPackage: createApi.post('/hps/admin/cpt/adSchedule/addElement')
}
